"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ButtonProps_1 = require("./ButtonProps");
var styles = require("./Button.css");
var ButtonStylesMaps_1 = require("./ButtonStylesMaps");
// import GlobalStyles from '@idp/styles';
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(props) {
        var _this = _super.call(this, props) || this;
        _this.onButtonClick = _this.onButtonClick.bind(_this);
        return _this;
    }
    Button.prototype.render = function () {
        var classes = [
            this.props.options.className,
            styles.button,
            this.getType(this.props.options),
            this.getColor(this.props.options),
            this.getSize(this.props.options),
            this.getTextColor(this.props.options),
        ];
        var disabled = false;
        if (this.props.data.disabled) {
            classes.push(styles.disabled);
            disabled = true;
        }
        else if (this.props.data.ariaDisabled) {
            classes.push(styles.disabled);
        }
        return (
        // <div>
        //    <GlobalStyles />
        React.createElement("button", __assign({ "data-test-id": this.props.testId, className: classes.join(' '), onClick: this.onButtonClick, disabled: disabled }, (this.props.data.ariaDisabled)
            ? { 'aria-disabled': this.props.data.ariaDisabled } : {}, { "aria-label": this.ariaLabelContent, role: this.props.options.role }),
            this.props.options &&
                this.props.options.iconFont &&
                this.props.options.iconName &&
                (!this.props.options.iconPosition ||
                    (this.props.options.iconPosition && this.props.options.iconPosition === ButtonProps_1.IconPosition.LEFT)) && (React.createElement("i", { className: [styles.icon, this.props.options.iconFont, this.props.options.iconName].join(' ') })),
            this.props.data.text,
            this.props.options &&
                this.props.options.iconFont &&
                this.props.options.iconName &&
                this.props.options.iconPosition &&
                this.props.options.iconPosition === ButtonProps_1.IconPosition.RIGHT && (React.createElement("i", { className: [styles.icon, this.props.options.iconFont, this.props.options.iconName].join(' ') })),
            this.props.options &&
                this.props.options.showLoader && (React.createElement("div", { className: styles.loader })))
        // </div>
        );
    };
    Button.prototype.getType = function (options) {
        if (options.type) {
            return ButtonStylesMaps_1.typesMap.get(options.type);
        }
        return ButtonStylesMaps_1.typesMap.get(ButtonProps_1.ButtonType.PRIMARY);
    };
    Button.prototype.getColor = function (options) {
        if (options.color) {
            return ButtonStylesMaps_1.colorsMap.get(options.color);
        }
        return null;
    };
    Button.prototype.getTextColor = function (options) {
        if (options.textColor) {
            return ButtonStylesMaps_1.textContrastColorMap.get(options.textColor);
        }
        return null;
    };
    Button.prototype.getSize = function (options) {
        if (options.size) {
            return ButtonStylesMaps_1.sizesMap.get(options.size);
        }
        return null;
    };
    Button.prototype.onButtonClick = function (e) {
        this.props.events.onClick();
    };
    Object.defineProperty(Button.prototype, "ariaLabelContent", {
        get: function () {
            if (this.props.options && this.props.options.accessibility) {
                return this.props.options.accessibility;
            }
            return this.props.data.text;
        },
        enumerable: false,
        configurable: true
    });
    Button.defaultProps = {
        options: {
            className: '',
            color: ButtonProps_1.ButtonColor.BLUE,
            role: ButtonProps_1.ButtonRole.BUTTON,
            type: ButtonProps_1.ButtonType.PRIMARY,
        },
    };
    return Button;
}(React.Component));
exports.default = Button;
//# sourceMappingURL=Button.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Button/Button.js
// module id = 121
// module chunks = 8